import { content, alert } from "../../utils/Modal";

export const AdvisoryBoardController = {
    index(): void {
        const list = document.querySelector<HTMLElement>(".sec-advisory-list");
        if (!list) { return; }

        const open = (card: HTMLElement): void => {
            const slug = card.dataset.advisorSlug ?? "";
            const name = card.dataset.advisorName ?? "";
            if (!slug) { return; }

            fetch(`/about/advisory-board/${encodeURIComponent(slug)}?modal=1`)
                .then((r) => {
                    if (!r.ok) { throw new Error(String(r.status)); }
                    return r.text();
                })
                .then((html) => content(html, name, "wide"))
                .catch(() => alert("Failed to load profile. Please try again."));
        };

        list.addEventListener("click", (e: MouseEvent) => {
            const card = (e.target as HTMLElement).closest<HTMLElement>("[data-advisor-card]");
            if (!card) { return; }
            e.preventDefault();
            open(card);
        });

        list.addEventListener("keydown", (e: KeyboardEvent) => {
            if (e.key !== "Enter" && e.key !== " ") { return; }
            const card = (e.target as HTMLElement).closest<HTMLElement>("[data-advisor-card]");
            if (!card) { return; }
            e.preventDefault();
            open(card);
        });
    },
};
